const ensureTrailingSlash = (value = '') => {
  if (!value) return '';
  return value.endsWith('/') ? value : `${value}/`;
};

const fromEnv = process.env.REACT_ASSET_BASE_URL || (typeof window !== 'undefined' ? window.__ASSET_BASE_URL__ : '');

export const ASSET_BASE_URL = ensureTrailingSlash(fromEnv);

export const withAssetBase = (path = '') => {
  if (!path || !ASSET_BASE_URL) return path;
  return `${ASSET_BASE_URL}${path.replace(/^\//, '')}`;
};
